import classnames from 'classnames'
import { CharStatus } from '../../lib/statuses'

type Props = {
  value?: string
  status?: CharStatus
  isCursor?: boolean
  isClickable?: boolean
  onClick?: () => void
}

export const Cell = ({ value, status, isCursor = false, isClickable = false, onClick }: Props) => {
  const classes = classnames(
    'w-14 h-14 max-[375px]:w-12 max-[375px]:h-12 max-[350px]:w-11 max-[350px]:h-11 max-[320px]:w-10 max-[320px]:h-10 border-solid border-2 flex items-center justify-center mx-0.5 max-[375px]:mx-0.5 max-[350px]:mx-0.5 max-[320px]:mx-0 text-4xl max-[375px]:text-3xl max-[350px]:text-3xl max-[320px]:text-2xl font-bold rounded dark:text-white',
    {
      'bg-white dark:bg-slate-900 border-slate-200 dark:border-slate-600':
        !status,
      'border-black dark:border-slate-100': value && !status,
      'bg-slate-500 dark:bg-slate-700 text-white border-slate-500 dark:border-slate-700':
        status === 'absent',
      'bg-green-700 text-white border-green-700': status === 'correct',
      'bg-yellow-400 dark:bg-yellow-400 text-white border-yellow-400 dark:border-yellow-400':
        status === 'present',
      'cell-animation': !!value,
      'cursor-pointer': isClickable,
      'ring-2 ring-blue-500 ring-opacity-50': isCursor && !status,
      'border-blue-500 dark:border-blue-400': isCursor && !status,
    }
  )

  return (
    <div 
      className={classes} 
      onClick={isClickable ? onClick : undefined}
    >
      {value}
    </div>
  )
}
